import PropTypes from "prop-types";

import cross from "../../../images/icons/cross.png";
import saveIcon from "../../../images/icons/save.png";
import ImageButton from "../../../utilities/Buttons/ImageBtn";
import ReactTable from "../../conteiners/ReactTable";
import {Select} from "../../Inputs";

const GuideSelectCard = ({
  label,
  fieldName,
  columns,
  tableData,
  selectOptions,
  onTableRowSelect = () => {},
  onAddBtnClick = () => {},
  onDeleteBtnClick = () => {},
  current = null,
  noButtons = false,
}) => {
  return (
    <div className="fcCol fGrow gap5" style={{width: "50%"}}>
      <div className="fdr">
        <Select
          label={label}
          name={fieldName}
          options={selectOptions}
          generalClassName="fGrow"
          inputClassName="fGrow"
          width="100%"
          autolabel
        />
        {/* <TextInput label={t(label) + ":"} name={fieldName} /> */}
        {!noButtons && (
          <>
            <ImageButton
              src={saveIcon}
              alt="add or update"
              className="btn__upload"
              width={1.6}
              height={1}
              onClick={onAddBtnClick}
            />
            <ImageButton
              src={cross}
              alt="delete"
              className="btn__upload"
              width={1.2}
              height={1.2}
              onClick={onDeleteBtnClick}
              disabled={!current}
            />
          </>
        )}
      </div>

      <ReactTable
        defaultData={tableData ?? []}
        columns={columns}
        onSelect={onTableRowSelect}
        current={current}
        // defaultValue={current}
        tableClassName="fGrow"
        className={"scrollX fGrow"}
        style={{height: "unset", minHeight: "6em"}}
      />
    </div>
  );
};

GuideSelectCard.propTypes = {
  label: PropTypes.string.isRequired,
  fieldName: PropTypes.string.isRequired,
  columns: PropTypes.array.isRequired,
  tableData: PropTypes.array,
  selectOptions: PropTypes.array.isRequired,
  onTableRowSelect: PropTypes.func,
  onAddBtnClick: PropTypes.func,
  onDeleteBtnClick: PropTypes.func,
  current: PropTypes.oneOfType([PropTypes.number, PropTypes.oneOf([null])]),
  noButtons: PropTypes.bool,
};

export default GuideSelectCard;
